import { createAction, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import { useRedux } from 'util/hook/redux';

import { wrapFetch } from 'util/api';

export const getBanner = createAction('GET_BANNER', async () => {
	const { status, data } = await wrapFetch('banners');

	if (status !== 200) {
		return { data: {}, list: [] };
	}

	const bannerData = {};
	const list = data.map(item => {
		bannerData[item.id] = item;

		return item.id;
	});

	return { data: bannerData, list };
});

const reducer = {
	banner: handleActions(
		{
			GET_BANNER_PENDING: state => ({
				...state,
				loading: true,
			}),

			GET_BANNER_FULFILLED: (state, action) => ({
				...state,
				data: action.payload.data,
				list: action.payload.list,
				loading: false,
			}),
		},
		{
			data: {},
			list: [],
			loading: false,
		},
	),
};

const mapHooksToState = createSelector(
	state => state.banner.data,
	state => state.banner.list,
	(data, list) => ({
		banner: list.map(id => data[id]),
	}),
);

export const useBanner = () => useRedux(mapHooksToState);

export default { reducer };
